import http from '@/http/fetch'

export const SaveLog = (params) => http.post('/toolsApi/log/saveLog', params,null)
export const SaveDataCountLog = (logType,useType,modelId) => http.get('/governApi/dataCountLog/save',{logType,useType,modelId})